import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { formatWeightDropTitle } from '../utils/weightControl';
import './RiderWeightAlert.css';

// Значок контроля веса: "!" в кружке справа от ФИО участника.
// Ставится, если вес на последней гонке снизился относительно предыдущих заездов
// (см. getRiderWeightDrop). Подсказка показывает вес по учтенным заездам.
//
// onOpenChart открывает график динамики веса — на мобильных подсказки по наведению нет,
// поэтому там значок кликабельный (по аналогии с графиком мест по этапам)
const RiderWeightAlert = ({ weightDrop, onOpenChart }) => {
  const { t, language } = useLanguage();

  if (!weightDrop) return null;

  const title = formatWeightDropTitle(weightDrop, t, language);

  if (onOpenChart) {
    return (
      <button
        type="button"
        className="rider-weight-alert rider-weight-alert-button"
        title={`${title}\n${t('results.weight_chart_open')}`}
        aria-label={`${title} — ${t('results.weight_chart_open')}`}
        onClick={(e) => {
          e.stopPropagation();
          onOpenChart();
        }}
      >
        !
      </button>
    );
  }

  return (
    <span className="rider-weight-alert" title={title} role="img" aria-label={title}>
      !
    </span>
  );
};

export default RiderWeightAlert;
